import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import Searchbox from "sushiweb/Searchbox";
import MenuItem from "sushiweb/MenuItem";
import Plus from "sushiweb/Icons/all/Plus";
import CrossCircle from "sushiweb/Icons/all/CrossCircle";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as RolesActions from "../../../store/actions/Roles";
import "./RolesFormModal.scss";
import { getInitialState, isValNull } from "../../../utils";
import styles from "../../../constants/assets/variables";
import NoFooterModal from "../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import styled from "styled-components";

const RolesFormModal = (props) => {
  const {
    handleClose,
    modalState,
    heading,
    getRolesList,
    activeFilters,
    activeRole,
    resetState,
    getAllActions,
    allActions,
    updateRole,
  } = props;
  const [initialState, setInitialState] = useState({
    name: "",
    actions: [],
  });
  const [initialActions, setInitialActions] = useState([]);
  const [actionsList, setActionsList] = useState([]);
  const [actionsListCopy, setActionsListCopy] = useState([]);
  const [dropdownVal, setDropdownVal] = useState("");
  const [error, setError] = useState("");

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const handleSelect = (val) => {
    const values = { ...initialState };
    if (!values["actions"].includes(val)) {
      const updatedActions = [...values["actions"]];
      updatedActions.push(val);
      values["actions"] = updatedActions;
      setInitialState(values);
    }
    setDropdownVal("");
  };

  const handleFilterClick = () => {
    if (initialState.name) {
      getRolesList({ name: initialState.name }).then((res) => {
        res && handleClose();
      });
    } else {
      setError("please select name");
    }
  };

  const handleSubmit = () => {
    const added_actions = initialState.actions.filter(
      (item) => !initialActions.includes(item)
    );
    const removed_actions = initialActions.filter(
      (item) => !initialState.actions.includes(item)
    );
    updateRole({
      role: initialState.name,
      add_actions: added_actions,
      remove_actions: removed_actions,
    }).then((res) => {
      if (res) {
        handleClose();
      }
    });
  };

  const handleMinus = (val) => {
    const values = { ...initialState };
    const updatedActions = [...values["actions"]];
    updatedActions.splice(values["actions"].indexOf(val), 1);
    values["actions"] = updatedActions;
    setInitialState(values);
  };

  const handleModalClose = () => {
    if (modalState === "Filter") {
      Object.keys(activeFilters).length > 0 &&
        getRolesList({}).then((res) => {
          resetState({ state: "activeFilters" });
        });
    }
    handleClose();
  };

  const handleInputChange = (query) => {
    if (isValNull(query)) {
      setActionsList(actionsListCopy);
      return;
    }
    // callback function, triggered when user types anything iin the input
    const filteredList = actionsListCopy.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase())
    );
    setActionsList(filteredList);
  };

  useEffect(() => {
    modalState !== "Filter" &&
      getAllActions().then((res) => {
        if (res && res.actions) {
          setActionsList(res.actions);
          setActionsListCopy(res.actions);
        }
      });
  }, []);

  // //get all Actions to populate in dropdown
  // useEffect(()=>{
  //   initialState.actions.length>0 && allActions.length===0 && getAllActions().then(res=>{
  //     if(res && res.actions){
  //       setActionsList(res.actions.filter(item => !initialState.actions.includes(item)));
  //     }
  //   });
  // },[initialState.actions]);

  useEffect(() => {
    //set the initial state of form in modal
    if (activeRole && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeRole[key]
          ? activeRole[key]
          : getInitialState(initialState, key);
      });
      setInitialState(values);
      setInitialActions([...values.actions]);
    }
    if (activeFilters && modalState === "Filter") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFilters[key] ? activeFilters[key] : "";
      });
      setInitialState(values);
    }
  }, [activeRole, activeFilters]);

  return (
    <NoFooterModal
      header
      heading={heading}
      id="rolesFormModal"
      handleClose={handleModalClose}
      id="rolesFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          {modalState === "Filter" && (
            <Button
              data-testid="rolesFormClearBtn"
              onClick={handleModalClose}
              className="sushi-btn"
            >
              Clear
            </Button>
          )}
          <Button
            data-testid="rolesFormSubmitBtn"
            onClick={modalState === "Filter" ? handleFilterClick : handleSubmit}
            className="sushi-btn"
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </BottomSectionModal>
      }
    >
      <div id="roles-form">
        <Input
          disabled={modalState !== "Filter"}
          errorMsg={error}
          borderColor={styles.primaryColor}
          id="sushi-input"
          fullWidth
          onChange={(e) => handleChange("name", e)}
          value={initialState.name}
          label="Role Name"
        />
        {modalState !== "Filter" && (
          <React.Fragment>
            <SearchboxWrapper>
              <Searchbox
                width={"100%"}
                placeholder="Add more actions"
                className="sushi-searchbox-compact"
                helperText=""
                onChange={handleInputChange}
                onSelect={handleSelect}
                showDropdownArrow={false}
                value={""}
                enforceValue
                forceRenderValue={true}
              >
                {actionsList.map((action, index) => {
                  return (
                    <MenuItem
                      value={action}
                      label={action}
                      leftIcon={<Plus />}
                    />
                  );
                })}
              </Searchbox>
            </SearchboxWrapper>
            <div className="actions-list mt-20">
              <h3>Actions</h3>
              {initialState.actions.map((action, idx) => {
                return (
                  <div
                    className="action-item flex items-center justify-between p-10"
                    key={idx}
                  >
                    <span>{action}</span>
                    <CrossCircle
                      className="cross-icon"
                      onClick={() => handleMinus(action)}
                    />
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        )}
      </div>
    </NoFooterModal>
  );
};

const SearchboxWrapper = styled.section`
  padding-right: 10px;
`;

function mapStateToProps(state) {
  const { Roles } = state;
  return {
    rolesList: Roles.rolesList,
    activeRole: Roles.activeRole,
    activeFilters: Roles.activeFilters,
    allActions: Roles.allActions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRolesList: bindActionCreators(RolesActions.getRolesList, dispatch),
    getRolesActions: bindActionCreators(RolesActions.getRolesActions, dispatch),
    resetState: bindActionCreators(RolesActions.resetState, dispatch),
    getAllActions: bindActionCreators(RolesActions.getAllActions, dispatch),
    updateRole: bindActionCreators(RolesActions.updateRole, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RolesFormModal);
